import postscribe from "postscribe";
export const mapScript = (type, element) => {
  switch (type) {
    case FINNISH_FORM:
      postscribe(
        element,
        "<script src=https://www.emailmeform.com/builder/forms/jsform/5a2s8uqodx></script>"
      );
      break;
    case DUTCH_CALCULATION:
      let dutchScript = getDutchCalculation();
      element.appendChild(dutchScript);
      break;
    case POLISH_FORM:
      let script = getPolishFormScript();
      element.appendChild(script);
      break;
    case POLISHSCRIPT_FORM:
      postscribe(
        element,
        "<script src=https://www.emailmeform.com/builder/forms/jsform/ZfC4YEXtBJd6P></script>"
      );
      break;
  }
};

const getDutchCalculation = () => {
  const script = document.createElement("script");

  script.innerHTML = `window.kot = (function (d, s, id) {
		var js, fjs = d.getElementsByTagName(s)[0],
		t = window.kot || {};
		if (d.getElementById(id))
		return t;
		js = d.createElement(s);
		js.id = id;
		js.src = "https://www.kinderopvang-rekentool.nl/rekenmodule/API/widget.js?widgetId=norlandia2";
		fjs.parentNode.insertBefore(js, fjs);
		t._e = [];
		t.ready = function (f) {
		t._e.push(f);
		};
		return t;
		}(document, "script", "kinderopvangtoeslag-js"));
	`;
  return script;
};

const getPolishFormScript = () => {
  const script = document.createElement("script");

  script.setAttribute("data-b24-form", "inline/12/a1a976");
  script.setAttribute("data-skip-moving", "true");
  script.innerHTML = `(function(w,d,u){
			                var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
			                var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
			        })(window,document,'https://cdn.bitrix24.pl/b16707095/crm/form/loader_12.js');
			`;
  return script;
};

const FINNISH_FORM = "Finnish form";
const POLISH_FORM = "Polish form";
const DUTCH_CALCULATION = "Dutch calculation";
const POLISHSCRIPT_FORM = "Polish script form";
